import { REPORT_TYPES, TIME_RANGES, FREQUENCY, FOLLOW_UP_DATE_RANGE_CHOICES, FOLLOW_UP_DATE_RANGE, FOLLOW_UP_DATE_RANGE_DISPLAY_NAMES, DEFAULT_TIME_RANGES_FOR_REPORT_TYPE } from '../components/Constants'
import { isExtendedDataRangeEnabled } from '../components/DataProvider';
import momentDate from "./moment-date"
import { findDiffInMonths, getOnlyDateComponent, getPastDateByMonths, isFalsy, isSofaReportType, shouldDateBeStartOfMonth, shouldDateBeStartOfMonthForBundle } from "./util"
import isEmpty from 'lodash/isEmpty'
import { extractQueryParamsFromURL } from '../mappers/Report'
import moment from 'moment-timezone';

// for cases when fact find survey is present, ATP always goes in through survey params
export const isAmountToProveFieldRequired = (values) => {
  if ((!values.selectedSourceOfFundsSurvey && !values.selectedFactFindSurvey) || isAmountToProveMandatory(values))
    return true;
  else
    return false;
};

export const isAmountToProveMandatory = (values, amountFieldRequired) => {
  return (
    (!values.selectedFactFindSurvey && !values.selectedSourceOfFundsSurvey && amountFieldRequired) ||
    (
    (values.selectedSourceOfFundsSurvey && !values.selectedFactFindSurvey) ||
    (values.selectedFactFindSurvey &&
      values.selectedSourceOfFundsSurvey &&
      (!values.selectedFactFindSurvey.outputParams ||
        (values.selectedFactFindSurvey.outputParams &&
          !values.selectedFactFindSurvey.outputParams.includes('AMOUNT_TO_PROVE'))))
    )
  );
};

export const getPastDateFromFrequency = (date, frequency) => {
  if (!frequency || FREQUENCY.ONCE === frequency) return;

  let periodStartDate = null;
  if (FREQUENCY.MONTHLY === frequency)
    periodStartDate = momentDate(date).subtract(1, "months").toDate();
  else if (FREQUENCY.QUARTERLY === frequency)
    periodStartDate = momentDate(date).subtract(3, "months").toDate();
  else periodStartDate = momentDate(date).subtract(1, "years").toDate();

  if (isEndOfMonth(date)) {
    periodStartDate = momentDate(periodStartDate).add(1, "months").startOf("month");
  } else {
    periodStartDate = momentDate(periodStartDate).add(1, "days").toDate();
  }

  return periodStartDate;
};

export function isEndOfMonth(dt) {
  if (typeof dt === "string") dt = new Date(dt);

  var date = new Date(dt.getTime()),
    month = date.getMonth();

  date.setDate(date.getDate() + 1);
  return date.getMonth() !== month;
}

export const validateStartDate = (value, allValues) => {
  const extendedDataRangeEnabled = isExtendedDataRangeEnabled();
  const { endDate, reportType, multiReportType, timeRange, accounts } = allValues;
  // The accounts is an indicator that the request is for a matter

  if (value && timeRange === TIME_RANGES.CUSTOM) {
    if (
      !accounts &&
      momentDate(value).isBefore(getPastDateByMonths(new Date(), 24), "days") &&
      !extendedDataRangeEnabled
    ) {
      return "The start date cannot be more than 24 months before current date.";
    }

    if (
      momentDate(value).isBefore(getPastDateByMonths(new Date(), 12*20), "days")
    ) {
      return "The start date cannot be more than 20 years before current date.";
    }

    if (
      endDate &&
      shouldDateBeStartOfMonthForBundle(reportType, multiReportType) &&
      findDiffInMonths(value, endDate) < 3
    ) {
      return "The time range must be at least 3 months.";
    }
    if(
      value && 
      !endDate && 
      isSofaReportType(reportType, multiReportType) &&
      findDiffInMonths(value, new Date()) < 3
    ){
      return "The time range must be at least 3 months from the current date.";
    }
  }
};

export const validateEndDate = (value, allValues) => {
  const { startDate, timeRange } = allValues;

  if (startDate && value && timeRange === TIME_RANGES.CUSTOM) {
    if (momentDate(value).isBefore(startDate)) {
      return "The start date must be a date before or equal to end date.";
    }
    if (momentDate(value).isAfter(new Date())) {
      return "The end date must be a date before or equal to current date.";
    }
  }
};

export const validateReportRequestCreation = (values, fields) => {

  const extendedDataRangeEnabled = isExtendedDataRangeEnabled();
  const { startDate, endDate, reportType, accounts, multiReportType } = values;
  const errors = {};

  if (startDate && TIME_RANGES.CUSTOM === values.timeRange) {
    if (!accounts && momentDate(startDate).isBefore(getPastDateByMonths(new Date(), 24), "days") && !extendedDataRangeEnabled) {
      errors.startDate =
      "The start date cannot be more than 24 months before current date.";
    }
    if(momentDate(startDate).isBefore(getPastDateByMonths(new Date(), 12*20), "days")){
      errors.startDate =
      "The start date cannot be more than 20 years before current date.";
    }
    if (endDate && momentDate(endDate).isBefore(startDate)) {
      errors.endDate =
        "The start date must be a date before or equal to end date.";
    }
    if (endDate && momentDate(endDate).isAfter(new Date())) {
      errors.endDate =
        "The end date must be a date before or equal to current date.";
    }
     
    if (
      endDate &&
      shouldDateBeStartOfMonthForBundle(reportType, multiReportType) &&
      findDiffInMonths(startDate, endDate) < 3
    ) {
      errors.startDate = "The time range must be at least 3 months.";
    }
    if(
      startDate && 
      !endDate && 
      isSofaReportType(reportType, multiReportType) &&
      findDiffInMonths(startDate, new Date()) < 3
    ){
      errors.startDate = "The time range must be at least 3 months from the current date.";
    }
  }
  return errors;
};

export const showAmountCurrencyAndCurrencyToProve = (reportType, multiReportType) => {
  return (
    reportType === REPORT_TYPES.PROOF_OF_FUNDS ||
    reportType === REPORT_TYPES.SOURCE_OF_FUNDS_DATA ||
    reportType === REPORT_TYPES.SOURCE_OF_FUNDS_ANALYSIS ||
    reportType === REPORT_TYPES.SURVEY_ONLY ||
    multiReportType?.includes(REPORT_TYPES.PROOF_OF_FUNDS) ||
    multiReportType?.includes(REPORT_TYPES.SOURCE_OF_FUNDS_DATA) ||
    multiReportType?.includes(REPORT_TYPES.SOURCE_OF_FUNDS_ANALYSIS) ||
    multiReportType?.includes(REPORT_TYPES.SURVEY_ONLY)
  );
};

export const showTimeRange = (reportType) => {
  return (
    reportType === REPORT_TYPES.SOURCE_OF_FUNDS_DATA ||
    reportType === REPORT_TYPES.SOURCE_OF_FUNDS_ANALYSIS ||
	  reportType === REPORT_TYPES.TRANSACTION_ANALYSIS ||
	  reportType === REPORT_TYPES.CLAIMS_REVIEW ||
	  reportType === REPORT_TYPES.TRANSACTION_DOWNLOAD ||
    reportType === REPORT_TYPES.INCOME ||
    reportType === REPORT_TYPES.AFFORDABILITY ||
	  reportType === REPORT_TYPES.DETAILED_AFFORDABILITY 
  );
};

export const showTimeRangeForBundle = (reportTypes) => {
  return reportTypes?.includes(REPORT_TYPES.SOURCE_OF_FUNDS_DATA) ||
    reportTypes?.includes(REPORT_TYPES.SOURCE_OF_FUNDS_ANALYSIS) ||
    reportTypes?.includes(REPORT_TYPES.TRANSACTION_ANALYSIS) ||
    reportTypes?.includes(REPORT_TYPES.CLAIMS_REVIEW) ||
    reportTypes?.includes(REPORT_TYPES.TRANSACTION_DOWNLOAD) ||
    reportTypes?.includes(REPORT_TYPES.INCOME) ||
    reportTypes?.includes(REPORT_TYPES.AFFORDABILITY) ||
    reportTypes?.includes(REPORT_TYPES.DETAILED_AFFORDABILITY)
}

export const showFollowUpDataRangeInput = (reportType, multiReportType) => {
  return (
    reportType === REPORT_TYPES.INCOME ||
    reportType === REPORT_TYPES.AFFORDABILITY ||
    reportType === REPORT_TYPES.DETAILED_AFFORDABILITY ||
    reportType === REPORT_TYPES.CLAIMS_REVIEW ||
    multiReportType?.includes(REPORT_TYPES.INCOME) ||
    multiReportType?.includes(REPORT_TYPES.AFFORDABILITY) ||
    multiReportType?.includes(REPORT_TYPES.DETAILED_AFFORDABILITY) ||
    multiReportType?.includes(REPORT_TYPES.CLAIMS_REVIEW)
  );
}

export const showPayslipVerificationInput = (reportType, multiReportType) => {
  return (
    reportType === REPORT_TYPES.INCOME ||
    reportType === REPORT_TYPES.AFFORDABILITY ||
    reportType === REPORT_TYPES.DETAILED_AFFORDABILITY ||
    multiReportType?.includes(REPORT_TYPES.INCOME) ||
    multiReportType?.includes(REPORT_TYPES.AFFORDABILITY) ||
    multiReportType?.includes(REPORT_TYPES.DETAILED_AFFORDABILITY)
  );
};

export const filterFieldBasedOnName = (fieldName, fields) => {
  const filteredList = fields?.filter(field => field.name === fieldName)
  return filteredList?.length > 0 ? filteredList[0] : null
}

export const getPossibleChoicesAndDefaultValue = (reportType, timeRangeField) => {
  // getting possible choices and default values based on reportType
  if (reportType && !isEmpty(timeRangeField?.possibleValues)) {
    const possibleChoicesAndDefaultValues = timeRangeField.possibleValues.filter(
      (item) => item.reportType === reportType
    );
    if (possibleChoicesAndDefaultValues) return(possibleChoicesAndDefaultValues[0]);
    else return null;
  }
  else return null;
}

export const getDefaultValueForTimeRangeInBundle = (multiReportType, timeRangeField) => {
  const { possibleValues, defaultValue: defaultValueFromTemplate } = timeRangeField ?? {};
  
  if (!isEmpty(possibleValues)) {
    return possibleValues.includes(defaultValueFromTemplate) 
      ? TIME_RANGES[defaultValueFromTemplate]
      : TIME_RANGES[possibleValues[0]];
  }

  const timeRangePermissibleReportType = multiReportType?.find(showTimeRange);
  return DEFAULT_TIME_RANGES_FOR_REPORT_TYPE[timeRangePermissibleReportType];
};

export const areDependentValidationsSatisfied = (dependsOn, formStateValues) => {
  if (!dependsOn) return true;

  let result = true;
  dependsOn.forEach((dependent) => {
    switch (dependent.operator) {
      case 'EQUALS':
        if (formStateValues[dependent.field] === dependent.values[0]) result = result && true;
        else result = result && false;
        break;

      case 'WITHIN_RANGE':
        if (dependent.values.includes(formStateValues[dependent.field])) result = result && true;
        else result = result && false;
        break;

      case 'LESS_THAN':
        if (formStateValues[dependent.field] < dependent.values[0]) result = result && true;
        else result = result && false;
        break;

      case 'GREATER_THAN':
        if (formStateValues[dependent.field] > dependent.values[0]) result = result && true;
        else result = result && false;
        break;

      default:
        break;
    }
  });
  return result;
};

export const canFieldBeHidden = (hidden, required, defaultValue) => {
  if (hidden) return !required || (required && defaultValue);
  else return false;
};

export const showSurveyATP = (values) => {
  return ( values.reportType === REPORT_TYPES.SOURCE_OF_FUNDS_ANALYSIS 
    || values.reportType === REPORT_TYPES.SOURCE_OF_FUNDS_DATA
    || values?.multiReportType?.includes(REPORT_TYPES.SOURCE_OF_FUNDS_ANALYSIS)
    || values?.multiReportType?.includes(REPORT_TYPES.SOURCE_OF_FUNDS_DATA)) 
    && !isEmpty(values.selectedSourceOfFundsSurvey);
}

export const displaySurveyATPonShow = (reportType, surveySize) => {
  return (( reportType === REPORT_TYPES.SOURCE_OF_FUNDS_ANALYSIS 
        || reportType === REPORT_TYPES.SOURCE_OF_FUNDS_DATA 
        || reportType === REPORT_TYPES.TRANSACTION_ANALYSIS ) 
        && surveySize > 0 );
}

export const showInsights = (reportType) => {
  return ( reportType === REPORT_TYPES.SOURCE_OF_FUNDS_ANALYSIS )
}

export const showInsightsForBundle = (reportTypes) => {
  return reportTypes?.includes(REPORT_TYPES.SOURCE_OF_FUNDS_ANALYSIS)
}

export const showLargeItemInput = (reportType) => {
  return ( reportType === REPORT_TYPES.SOURCE_OF_FUNDS_ANALYSIS )
}

export const showLargeItemInputForBundle = (reportTypes) => {
  return reportTypes?.includes(REPORT_TYPES.SOURCE_OF_FUNDS_ANALYSIS)
}

export const showForExpansion = (reportType) => {
  return ( reportType === REPORT_TYPES.INCOME ||
    reportType === REPORT_TYPES.AFFORDABILITY ||
    reportType === REPORT_TYPES.DETAILED_AFFORDABILITY ||
    reportType === REPORT_TYPES.CLAIMS_REVIEW ||
    reportType === REPORT_TYPES.SOURCE_OF_FUNDS_ANALYSIS ||
    reportType === REPORT_TYPES.TRANSACTION_ANALYSIS
  );
}

export const showForIncome = (reportType) => {
  return ( reportType === REPORT_TYPES.INCOME ||
    reportType === REPORT_TYPES.AFFORDABILITY ||
    reportType === REPORT_TYPES.DETAILED_AFFORDABILITY);
}

export const showForPersonaTemplate = (reportType) => {
  return reportType === REPORT_TYPES.IDENTITY_VERIFICATION;
}

export const createFollowUpDataRangeChoices = (possibleValues) => {  
  
  if (isEmpty(possibleValues)) return FOLLOW_UP_DATE_RANGE_CHOICES

  const options = [];
  possibleValues.forEach((value) => {
    if (FOLLOW_UP_DATE_RANGE.hasOwnProperty(value)){
      options.push({
        id : FOLLOW_UP_DATE_RANGE[value],
        name : FOLLOW_UP_DATE_RANGE_DISPLAY_NAMES[value]
      })
    }
  })

  if (isEmpty(options)) return FOLLOW_UP_DATE_RANGE_CHOICES

  return options;
}

export const getDefaultValueForFollowUpDataRange = (followUpDataRangeField, followUpDataRangeChoices) => {
  
  let followUpDataRangeIds = followUpDataRangeChoices.map(choice => choice.id);

  if(followUpDataRangeIds.includes(followUpDataRangeField?.defaultValue)){
    return followUpDataRangeField?.defaultValue;
  }else{
    return undefined;
  }

}

export const prepareStartDate = (fromField, startDate, isMatter, reportType, startDateFromUrl) => {

  if (startDateFromUrl) return moment(startDateFromUrl, 'DD/MM/YYYY').toDate().toString();

  if (fromField && fromField.defaultValue) {
    return fromField.defaultValue;
  }
  
  if (isMatter && !isFalsy(startDate)) {
    if (shouldDateBeStartOfMonth(reportType)) {
      return getOnlyDateComponent(momentDate(startDate).startOf('month')).toString();
    }
    return startDate;
  }  
}

export const prepareEndDate = (endDate, toField, endDateFromUrl) => {
  if (endDateFromUrl) return moment(endDateFromUrl, 'DD/MM/YYYY').toDate().toString();

  if(toField && toField.hasOwnProperty("defaultValue")){
    return toField.defaultValue;
  }
  
  if(!isFalsy(endDate)){
    return endDate;
  }

  return getOnlyDateComponent(new Date()).toString();
}

// Resolves a template URL param (name) to the matching template ID.
// Comparison is case-insensitive and ignores all whitespace
export const resolveTemplateFromUrl = (templateParam, templates) => {
  if (isEmpty(templateParam)) return null;

  const normalize = (s) => s?.replace(/\s+/g, '').toLowerCase();
  const match = templates.find(t => normalize(t.name) === normalize(templateParam));
  return match?.id ?? null;
};

// Extracts all first-level field URL params in one place with alias resolution.
export const extractFirstLevelUrlParams = (search) => ({
  contactName: extractQueryParamsFromURL(search, 'contactName'),
  emailAddress: extractQueryParamsFromURL(search, 'emailAddress'),
  businessName: extractQueryParamsFromURL(search, 'businessName'),
  descriptionOfMatter: extractQueryParamsFromURL(search, 'descriptionOfMatter'),
  clientReference: extractQueryParamsFromURL(search, 'clientReference'),
  emailText: extractQueryParamsFromURL(search, 'emailText'),
  notificationRecipients: extractQueryParamsFromURL(search, 'notificationRecipients'),
  callbackUrl: extractQueryParamsFromURL(search, 'callbackUrl'),
});

// Resolves the default value for a first-level field.
// Priority: URL param → matter context (contactName, emailAddress only) → template defaultValue.
export const resolveFirstLevelFieldDefault = (field, urlParams, context = {}) => {
  const { isMatterShow, matterName, userEmail } = context;

  if (field.name === 'contactName') {
    return urlParams.contactName ?? (isMatterShow ? matterName : field.defaultValue);
  }

  if (field.name === 'emailAddress') {
    return urlParams.emailAddress ?? (isMatterShow ? userEmail : field.defaultValue);
  }

  if (isMatterShow && field.name === 'notificationRecipients') {
    return undefined;
  }

  return urlParams[field.name] ?? field.defaultValue;
};